import { defineStore } from "pinia";
import { UserNotes } from '@busy-human/k9-library';

export const useUserNotes = defineStore('user-notes', () => {
    const notes = new Map<string, string>();

    async function getNotes(uid: string) {
        try {
            if(notes.has(uid)) return notes.get(uid) || '';
            else {
                const res = await UserNotes.Collection.docEntity(uid).fetch();
                notes.set(uid, res.notes);
                return res.notes;
            }
        } catch (e) {
            return '';
        }
    }

    async function setNotes(uid: string, note: string) {
        notes.set(uid, note);
        await UserNotes.Collection.docEntity(uid).set({notes: note});
    }

    return { getNotes, setNotes }
})